import styled from "styled-components";

/** Full-screen modal backdrop for toolbar dialogs (portaled to document.body). */
export const PopupOverlay = styled.div`
   display: flex;
   justify-content: center;
   align-items: center;
   position: fixed;
   inset: 0;
   width: 100%;
   height: 100%;
   background-color: rgba(30, 39, 46, 0.55);
   z-index: 1200;
   padding: 16px;
   box-sizing: border-box;

   > div {
      position: relative;
      background-color: #fff;
      padding: 30px;
      border-radius: 12px;
      box-shadow: 0 24px 60px rgba(15, 23, 42, 0.22);
      max-height: calc(100vh - 32px);
      overflow: auto;

      .close {
         display: flex;
         align-items: center;
         justify-content: center;
         position: absolute;
         top: 18px;
         right: 18px;
         transition: all 0.2s ease-in-out;
         cursor: pointer;
         width: 32px;
         height: 32px;
         border-radius: 8px;
         opacity: 0.8;
         color: #64748b;

         &:hover {
            background-color: rgba(241, 245, 249, 1);
            opacity: 1;
            color: #0f172a;
         }
      }

      .content {
         .title {
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            .icon {
               display: flex;
               align-items: center;
               justify-content: center;
               width: 36px;
               height: 36px;
               background-color: rgba(219, 234, 254, 1);
               color: rgba(37, 99, 235, 1);
               border-radius: 8px;
               margin-right: 10px;
               flex-shrink: 0;
            }
            h3 {
               font-weight: 600;
               font-size: 18px;
               color: #0f172a;
            }
         }
      }
   }

   &.reset > div {
      width: min(455px, calc(100vw - 32px));

      .content {
         .title .icon {
            background-color: rgba(254, 226, 226, 1);
            color: rgba(220, 38, 38, 1);
         }
         .info {
            > div:first-of-type {
               box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
               background-color: rgba(254, 242, 242, 1);
               border: 1px solid rgba(254, 202, 202, 1);
               border-radius: 7.5px;
               padding: 15px;
               margin-bottom: 25px;

               span:first-of-type {
                  display: block;
                  font-size: 15px;
                  font-weight: 500;
                  color: #991b1b;
                  margin-bottom: 6px;
               }
               span:last-of-type {
                  display: block;
                  font-size: 13px;
                  color: #b91c1c;
                  line-height: 1.45;
               }
            }
            label {
               display: block;
               font-size: 13px;
               font-weight: 600;
               color: #334155;
               margin-bottom: 8px;
            }
         }
         .tip {
            display: flex;
            gap: 10px;
            align-items: flex-start;
            background: #fffbeb;
            border: 1px solid #fde68a;
            border-radius: 8px;
            padding: 12px 14px;
            margin: 18px 0 22px;
            font-size: 13px;
            color: #92400e;
            line-height: 1.45;

            > span:first-of-type {
               flex-shrink: 0;
               color: #d97706;
            }
            span span {
               font-weight: 700;
            }
         }
         .action {
            display: flex;
            justify-content: flex-end;
            gap: 10px;

            button {
               display: inline-flex;
               align-items: center;
               justify-content: center;
               height: 38px;
               padding: 0 16px;
               border-radius: 8px;
               border: 1px solid #e2e8f0;
               background: #fff;
               cursor: pointer;
               font-size: 14px;
               font-weight: 600;
            }
            .cancel:hover { background: #f8fafc; }
            button:not(.cancel) {
               background: #dc2626;
               border-color: #dc2626;
               color: #fff;
            }
            button:not(.cancel):disabled {
               opacity: 0.45;
               cursor: not-allowed;
            }
         }
      }
   }
`;
